import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "75%",
      "persistent": ""
    },
    on: {
      "close": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.createDialog.title')))];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_vm.editItem.id ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "data-cy": "save_button",
            "prepend-icon": "fa-save",
            "disabled": _vm.saveDisabled
          },
          on: {
            "click": _vm.update
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.update')) + "\n    ")]) : _c('core-button', {
          attrs: {
            "color": _vm.color,
            "data-cy": "save_button",
            "prepend-icon": "fa-save",
            "disabled": _vm.saveDisabled
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "3"
    }
  }, [_c('core-account-selector', {
    attrs: {
      "required": ""
    },
    model: {
      value: _vm.selectedAccount,
      callback: function ($$v) {
        _vm.selectedAccount = $$v;
      },
      expression: "selectedAccount"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "3"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "data-cy": "title_input",
      "label": "Title",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": ""
    },
    model: {
      value: _vm.viewTitle,
      callback: function ($$v) {
        _vm.viewTitle = $$v;
      },
      expression: "viewTitle"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "description_input",
      "label": "Description",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.viewDescription,
      callback: function ($$v) {
        _vm.viewDescription = $$v;
      },
      expression: "viewDescription"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('custom-multi-search', {
    attrs: {
      "searchTypes": _vm.filteredSearchTypes,
      "searchItems": _vm.searchItems,
      "operator": _vm.searchOperator,
      "defaultSearchType": {
        param: 'quickSearch',
        text: 'Quick search'
      },
      "showOperatorDropdown": ""
    },
    on: {
      "updated": _vm.searchUpdated
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };